/* NTH mega-menu v1 — interaction layer for snippets/megamenu-shop-all-rendered.liquid
 *
 * Desktop: hover a category to reveal that category's panel. Within the panel,
 *   hover a subcategory with types to reveal its type column. Concerns column
 *   is always visible if data exists.
 * Mobile (<992px): tap a category to slide its panel in from the right.
 *   A back-button (CSS pseudo-element + JS handler) closes the panel.
 *
 * Skipped for v1 (P1 backlog): safe-triangle hover, full focus trap, arrow-key nav.
 */

(function () {
  'use strict';

  const HOVER_DELAY = 100;
  const MOBILE_BP = 991; // matches CSS

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BP + 'px)').matches;
  }

  function init(root) {
    const cats = Array.from(root.querySelectorAll('.mm__cat'));
    const panels = Array.from(root.querySelectorAll('.mm__panel'));
    const panelByHandle = new Map();
    panels.forEach((p) => panelByHandle.set(p.getAttribute('data-mm-panel-for'), p));

    let hoverTimer = null;
    let activeCatHandle = null;

    function showPanel(handle) {
      if (activeCatHandle === handle) return;
      panels.forEach((p) => {
        p.hidden = true;
        p.classList.remove('is-open');
      });
      cats.forEach((c) => c.classList.remove('is-active'));

      const panel = panelByHandle.get(handle);
      const cat = cats.find((c) => c.getAttribute('data-mm-cat') === handle);
      if (panel) {
        panel.hidden = false;
        panel.classList.add('is-open');
      }
      if (cat) cat.classList.add('is-active');
      activeCatHandle = handle;

      // Reset type columns + subcat active state — wait for hover on a subcat to reveal its types
      if (panel) {
        const types = panel.querySelectorAll('.mm__col--types');
        types.forEach((t) => (t.hidden = true));
        const subs = panel.querySelectorAll('.mm__sub');
        subs.forEach((s) => s.classList.remove('is-active'));
      }
    }

    function clearPanels() {
      panels.forEach((p) => {
        p.hidden = true;
        p.classList.remove('is-open');
      });
      cats.forEach((c) => c.classList.remove('is-active'));
      activeCatHandle = null;
    }

    /* ---------- Desktop hover ---------- */
    cats.forEach((cat) => {
      const handle = cat.getAttribute('data-mm-cat');
      const hasPanel = cat.getAttribute('data-mm-has-panel') === 'true';

      cat.addEventListener('mouseenter', () => {
        if (isMobile()) return;
        if (!hasPanel) {
          clearPanels();
          return;
        }
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => showPanel(handle), HOVER_DELAY);
      });

      cat.addEventListener('click', (e) => {
        if (!isMobile()) return;
        if (hasPanel) {
          e.preventDefault();
          showPanel(handle);
        }
      });
    });

    /* ---------- Subcategory hover → type column swap (desktop). Active subcat just goes bold. ---------- */
    panels.forEach((panel) => {
      const subs = panel.querySelectorAll('.mm__sub');
      const typeCols = panel.querySelectorAll('.mm__col--types');

      subs.forEach((sub) => {
        const hasTypes = sub.getAttribute('data-mm-has-types') === 'true';
        sub.addEventListener('mouseenter', () => {
          if (isMobile()) return;
          subs.forEach((s) => s.classList.remove('is-active'));
          sub.classList.add('is-active');

          const handle = sub.getAttribute('data-mm-sub');
          typeCols.forEach((t) => {
            t.hidden = !(hasTypes && t.getAttribute('data-mm-types-for') === handle);
          });
        });
      });
    });

    /* ---------- Mobile back button ---------- */
    panels.forEach((panel) => {
      panel.addEventListener('click', (e) => {
        if (!isMobile()) return;
        // The ::before pseudo-element area: detect clicks in top 50px
        const rect = panel.getBoundingClientRect();
        if (e.clientY - rect.top < 50) {
          panel.classList.remove('is-open');
          activeCatHandle = null;
        }
      });
    });

    /* ---------- ESC closes ---------- */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') clearPanels();
    });

    /* ---------- Reset on viewport switch ---------- */
    window.addEventListener('resize', () => {
      clearPanels();
    });
  }

  function boot() {
    document.querySelectorAll('[data-mm-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
